module.exports = __webpack_public_path__ + "static/img/coupon-product-box01.b9fec3f0.svg";